import { EARLY_ACCESS_TO_NEW_IN } from "../../state/modules/category/constants";
import { getLoyaltyBenefitType } from "../../state/modules/category/selectors";
import sdkProvider from "../sdkProvider";

const newInRedirect = async ({ state }) => {
  const loyaltyBenefitType = getLoyaltyBenefitType(state);

  if (loyaltyBenefitType !== EARLY_ACCESS_TO_NEW_IN) {
    return;
  }

  const loyaltyAvailable = await isLoyaltyAvailable();
  if (!loyaltyAvailable) {
    return;
  }

  const featuresSdk = await sdkProvider("features");
  await featuresSdk.onReady();

  const loyaltyNewInExperimentEnabled = await featuresSdk
    .getFeature("loyalty-new-in-today-lock-product")
    .isEnabled();

  if (loyaltyNewInExperimentEnabled) {
    return;
  }

  const identitySdk = await sdkProvider("identity");
  const isAuthenticated = await identitySdk.customer.isAuthenticated();

  if (!isAuthenticated) {
    identitySdk.login();

    return true;
  }
};

const isLoyaltyAvailable = async () => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");

    return await loyaltySdk.isLoyaltyAvailable();
  } catch (error) {
    return false;
  }
};

export default newInRedirect;
